import { apiClient, type PageEntity, type SiteListExEntity } from '@/libs/api'
import { type SitesListRequestQuery } from '@/libs/api/types'

export type FetchSitesListQuery = {
  tenantKey: string
  query: SitesListRequestQuery
}

export type FetchSitesListResponse = {
  data: SiteListExEntity[]
  pagination: PageEntity | null
}

// 地点マスタ一覧画面用 地点マスタ取得api
export const fetchSitesList = async (
  { tenantKey, query }: FetchSitesListQuery,
  signal?: AbortSignal
): Promise<FetchSitesListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .sites.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
